import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";
const state = {
    userData:[]
};
const getters = {
    userData: (state) => state.userData,
};

const actions = {
    [actionType.GET_DATA_USER_MANAGER]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get('/admin/users', {
                params: params,
            }).then(result => {
                let response = {
                    page: params.page,
                    data: result.data.data
                }
                commit(mutationType.SET_DATA_USER_MANAGER, response)
                resolve(result)
            })
            .catch(error => reject(error));
        });
    },
    [actionType.SET_USER_TO_ADMIN]: async function ({ commit }, params) {
		return new Promise((resolve, reject) => {
			api
				.put(`admin/users/${params.userId}/setUserAsAdmin`, {
                    setAdmin: params.setAdmin
					})
				.then(result => {
					resolve(result);
				})
				.catch(error => reject(error));
		});
	},
    [actionType.GET_USER_BY_EMAIL]: async function ({ commit }, params) {
		return new Promise((resolve, reject) => {
			api
				.get(`admin/users/byEmail`, {
						params: params
					})
				.then(result => {
					resolve(result);
				})
				.catch(error => reject(error));
		});
	},
    
    [actionType.UPDATE_INFO_USER_ADMIN]: async function ({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.put(`/admin/users/${data.id}`,data).then(result => {
                resolve(result)
            })
            .catch(error => reject(error));
        });
    },
    "UPDATE_INFO_USER_NORMAL": async function ({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.put(`/user`,data).then(result => {
                resolve(result)
            })
            .catch(error => reject(error));
        });
    },
    [actionType.DELETE_USER_ADMIN]: async function ({ commit }, id) {
        return new Promise((resolve, reject) => {
            api.delete(`/admin/users/${id}`).then(result => {
                
                resolve(result)

            })
            .catch(error => reject(error));
        });
    },
    "GET_DETAIL_USER": async function ({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.get(`/user/${data.id}`).then(result => {
                resolve(result)
            })
            .catch(error => reject(error));
        });
    },
    
   
};

const mutations = {
    [mutationType.SET_DATA_USER_MANAGER]: function (state, data) {
        if(data.page == 1)
        {
            state.userData = data.data
        }   
        else{
            state.userData = state.userData.concat(data.data)
        }
       
    },
    "UPDATE_EMPTY_DATA": function (state) {
        state.userData = [];
    }
   
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}